module.exports = __webpack_public_path__ + "img/7.ab20906.png";